export default "__VITE_ASSET__qa0wV8hK__"